const prod = '';
const dev = '';

export const BASE_URL = process.env.NODE_ENV === 'production' ?
  prod :
  dev;

export const MAP_CONFIG = {
  longitude: 90.54,
  latitude: 27.37,
  zoom: 8,
};

export const ADMINISTRATIVE_DIVISIONS = [
{ name: 'province', file: 'geojson/bd_province.json', label: 'Zone', key: 'Name' },
{ name: 'district', file: 'geojson/bd_district_2.json', label: 'District', key: 'DIST_NAME' }
]

export const ENABLE_AGG_FEATURES = false;
export const leafletURL = `https://api.mapbox.com/styles/v1/mapbox/streets-v10/tiles/256/{z}/{x}/{y}?access_token=${process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}`;



// WEBPACK FOOTER //
// ./src/config.js